import { render, staticRenderFns } from "./viewStockDetails.vue?vue&type=template&id=140da80a&"
import script from "./viewStockDetails.vue?vue&type=script&lang=js&"
export * from "./viewStockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports